import React, { useMemo } from 'react'
import { Box, Autocomplete, TextField } from '@mui/material'
import { useGetEcoAllStock } from '../../api/stock.eco'

export const StockFilter = (props) => {
  const { department, setDepartment, setItemId } = props

  const allStockRes = useGetEcoAllStock()
  const allStockData = allStockRes?.data ?? []

  const { departmentArray } = useMemo(() => {
    const departmentArray = allStockData
      .filter(
        (stock, index, array) =>
          array.findIndex((each) => each.department === stock.department) === index
      )
      .map((stock) => {
        return stock.department
      })
      .sort()

    return { departmentArray }
  }, [allStockData])

  const handleSelectDepartment = (event, value) => {
    setDepartment(value)
    setItemId('')
  }

  return (
    <Box mb={3}>
      <Autocomplete
        disablePortal
        id='department-autocomplete'
        options={departmentArray}
        sx={{ maxWidth: 650 }}
        onChange={handleSelectDepartment}
        size='small'
        renderInput={(params) => <TextField {...params} label='Item Group' />}
        value={department}
        isOptionEqualToValue={(option, value) => option.value === value.value}
      />
    </Box>
  )
}
